import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import IconVenmo from '@/icons/IconVenmo.vue';

Vue.use(Vuetify);

const opts = {
	theme: {
		themes: {
			light: {
				background: "#ECF5FD",
				primary: "#0093ee",
			},
			dark: {
				primary: "#0093ee",
			},
		},
	},
	icons: {
		iconfont: 'mdi',
    values: {
      venmo: {
        component: IconVenmo,
      },
    },
  },
};

export default new Vuetify(opts);
